export const getDefaultYAxisValueTicks = () => {
  return [0, 100000, 200000, 300000, 400000]
}
